import { TranslatePipe } from '../../filters/translate.pipe';
import { ItemNoContentComponent } from '../../components/item-no-content/item-no-content.component';
import { LoaderOverlayComponent } from '../../components/loader-overlay/loader-overlay.component';
import { CardServiceComponent } from '../../components/card-service/card-service.component';
import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import Session from '../../utils/session.service';
import ServiceRestServices from '../../services/service-rest.service';
import UrlUtil from '../../utils/url-util.service';
import CategoryService from '../../services/category.service';
import FetchingService from '../../services/fetching.service';
import AngularHelperService from '../../services/angular-helper.service';
import { Input } from '@angular/core';

@Component({
	standalone: true,
	selector: 'list-services',
	templateUrl: './list-services.component.html',
	imports: [ CommonModule, TranslatePipe, ItemNoContentComponent, LoaderOverlayComponent, CardServiceComponent, FormsModule ]
})
export class ListServicesComponent implements OnInit {
	private session: Session = inject(Session);
	private serviceRestServices: ServiceRestServices = inject(ServiceRestServices);
	private urlUtil: UrlUtil = inject(UrlUtil);
	private categoryService: CategoryService = inject(CategoryService);
	private fetchingService: FetchingService = inject(FetchingService);
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	
	@Input() initialLimit: any | undefined;
	@Input() descriptionDisabled: any | undefined;
	@Input() type: any | undefined;
	@Input() searchParams: any | undefined;
	
	vm: any = undefined;
	watcher: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		this.vm.isInitialized = false;
		this.vm.initialLimit = this.vm.initialLimit || 6;
		this.vm.additionalLimit = 48;
		this.vm.limit = this.vm.initialLimit;
		this.vm.services = [];
		var session = this.session.getSession();
		this.vm.user = session?.user;
		this.vm.sessionUserLanguage = this.vm.user?.deviceLanguage;
		this.vm.history = !!this.vm.type && this.vm.type.toLowerCase() === 'history';
		
		this.getCategories()
			.then(() => {
				this.vm.searchParams = this.vm.searchParams || {};
				if (!Object.keys(this.vm.searchParams).length) {
					this.vm.searchParams = this.urlUtil.getSearchParams();
				}

				this.searchDoctors(true);
			})
			.catch((e) => {
				console.error(e);
			});
		
		this.getTherapiesTranslations();
		
		var currentSearchParams = {};
		this.watcher = this.angularHelperService.createInterval(() => {
			if (!this.angularHelperService.isEqual(this.vm.searchParams, currentSearchParams)) {
				currentSearchParams = Object.assign({}, this.vm.searchParams);
				this.searchDoctors(true);
			}
		}, 300);
		
		this.vm.searchDoctors = this.searchDoctors;
	}
	

	ngOnDestroy() {
		if (this.watcher) {
			this.angularHelperService.cancelInterval(this.watcher);
		}
	}
	
	getCategories() {
		var deferred: any = this.angularHelperService.getDeferredPromise();
		if (this.vm.categories) {
			deferred.resolve();
		} else {
			this.categoryService.getFilters().then((categories) => {
				this.vm.categories = categories;
				deferred.resolve();
			});
		}
		
		return deferred.promise;
	}
	
	searchDoctors(isInitial) {
		if (this.vm.loading) {
			return;
		}
		this.vm.isInitial = isInitial;
		this.vm.loading = true;
		this.vm.searchParams = this.vm.searchParams || {};
		this.vm.limit = isInitial ? this.vm.initialLimit : this.vm.additionalLimit;
		// if (!Object.keys(this.vm.searchParams).length || !this.vm.categories) return;
		var params: any = {
			withoutTimeslot: true,
			start: isInitial ? 0 : this.vm.services.length,
			pageSize: this.vm.limit,
		};
		
		var category: any;
		if (this.vm.searchParams.category === 'EMPLOYER_PAYS') {
			params.subcategory = 'EMPLOYER_PAYS';
		} else if (this.vm.searchParams.category && this.vm.categories) {
			category = this.vm.categories.filter((item) => {
				return item.subcategory === this.vm.searchParams.category || item.furtherSubcategory === this.vm.searchParams.category;
			})[0];
		}
		if (!!this.vm.searchParams.conditions) {
			params.tags = Array.isArray(this.vm.searchParams.conditions)
				? this.vm.searchParams.conditions.join(',')
				: this.vm.searchParams.conditions;
		}
		if (!!this.vm.searchParams.therapies) {
			params.therapies = Array.isArray(this.vm.searchParams.therapies)
				? this.vm.searchParams.therapies.join(',')
				: this.vm.searchParams.therapies;
		}
		if (!!this.vm.searchParams.coachingTopics) {
			params.coachingTopics = Array.isArray(this.vm.searchParams.coachingTopics)
				? this.vm.searchParams.coachingTopics.join(',')
				: this.vm.searchParams.coachingTopics;
		}
		if (!category) category = { category: 'MEDICAL_AND_HEALTHCARE' };
		if (category && category.category) params.category = category.category;
		if (category && category.subcategory) params.subcategory = category.subcategory;
		if (this.vm.user?.origin == 'siffi.com' && !params.subcategory) {
			params.subcategory = "MENTAL_HEALTH";
		}
		if (category && category.furtherSubcategory) params.furtherSubcategory = category.furtherSubcategory;
		if (this.vm.searchParams.term && this.vm.searchParams.term.trim()) params.name = this.vm.searchParams.term.trim();
		if (this.vm.searchParams.typeOfAppointment) params.typeOfAppointment = this.vm.searchParams.typeOfAppointment;
		if (this.vm.searchParams.lang) params.languages = this.vm.searchParams.lang;
		if (this.vm.searchParams.location) params.location = this.vm.searchParams.location;
		if (this.vm.searchParams.weightLossServiceSupport) params.weightLossServiceSupport = this.vm.searchParams.weightLossServiceSupport;
		var session = this.session.getSession();
		params.origin = session?.user?.origin;
		
		var callback: any = (services) => {
			this.vm.loading = false;
			this.vm.isInitialized = true;
			this.setDescription(category);
			this.vm.services = isInitial ? services : this.vm.services.concat(services);
			this.vm.isLast = services.length < this.vm.limit;
			if (this.vm.searchParams && this.vm.searchParams.coachingTopics) {
				document.getElementById("serviceProviderListContainer").scrollIntoView();
			}
		}
		
		if (this.vm.history) {
			this.serviceRestServices.getServicesHistory(params, callback);
		} else {
			this.serviceRestServices.getServices(params, callback);
		}
	}
	
	setDescription(category) {
		this.vm.description = {
			title: category.translation || '',
			description: category.descriptionTranslation || '',
		};
	}
	
	getTherapiesTranslations() {
		var deferred: any = this.angularHelperService.getDeferredPromise();
		this.fetchingService.get('THERAPY_TOPIC_TRANSLATIONS', { params: { language: this.vm.sessionUserLanguage || 'en_GB' } })
			.then((response) => {
				this.vm.therapyTranslations = response;
				deferred.resolve();
			});
		return deferred.promise;
	}
	
}